var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeAutomation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81{fill:none;}.cls-2{clip-path:url(#clippath-8);}.cls-3{clip-path:url(#clippath-7);}.cls-4{clip-path:url(#clippath-6);}.cls-5{clip-path:url(#clippath-9);}.cls-6{clip-path:url(#clippath-5);}.cls-7{clip-path:url(#clippath-3);}.cls-8{clip-path:url(#clippath-4);}.cls-9{clip-path:url(#clippath-2);}.cls-10{clip-path:url(#clippath-1);}.cls-11{isolation:isolate;}.cls-82{fill:#027180;}.cls-83{fill:#eee;}.cls-84{fill:#fff;}.cls-85{fill:#ffe2b1;}.cls-86{fill:#fff5ee;}.cls-87{fill:#ffd07e;}.cls-88{fill:#993844;}.cls-89{fill:#979797;}.cls-90{fill:#015a66;}.cls-91{fill:#bfbfbf;}.cls-92{fill:#c0e0e4;}.cls-93{fill:#cacaca;}.cls-94{fill:#41939e;}.cls-95{fill:#446eae;}.cls-96{fill:#446ead;}.cls-97{fill:#436dac;}.cls-98{fill:#446dac;}.cls-99{fill:#4671b2;}.cls-100{fill:#4671b3;}.cls-101{fill:#4672b3;}.cls-102{fill:#4772b4;}.cls-103{fill:#4773b6;}.cls-104{fill:#4570b1;}.cls-105{fill:#4570b0;}.cls-106{fill:#456faf;}.cls-12{clip-path:url(#clippath-13);}.cls-13{clip-path:url(#clippath-14);}.cls-14{clip-path:url(#clippath-12);}.cls-15{clip-path:url(#clippath-11);}.cls-16{clip-path:url(#clippath-18);}.cls-17{clip-path:url(#clippath-19);}.cls-18{clip-path:url(#clippath-17);}.cls-19{clip-path:url(#clippath-16);}.cls-20{clip-path:url(#clippath-10);}.cls-21{clip-path:url(#clippath-15);}.cls-22{clip-path:url(#clippath-25);}.cls-23{clip-path:url(#clippath-22);}.cls-24{clip-path:url(#clippath-23);}.cls-25{clip-path:url(#clippath-24);}.cls-26{clip-path:url(#clippath-21);}.cls-27{clip-path:url(#clippath-20);}.cls-28{clip-path:url(#clippath-45);}.cls-29{clip-path:url(#clippath-40);}.cls-30{clip-path:url(#clippath-42);}.cls-31{clip-path:url(#clippath-41);}.cls-32{clip-path:url(#clippath-44);}.cls-33{clip-path:url(#clippath-43);}.cls-34{clip-path:url(#clippath-46);}.cls-35{clip-path:url(#clippath-47);}.cls-36{clip-path:url(#clippath-49);}.cls-37{clip-path:url(#clippath-48);}.cls-38{clip-path:url(#clippath-34);}.cls-39{clip-path:url(#clippath-30);}.cls-40{clip-path:url(#clippath-32);}.cls-41{clip-path:url(#clippath-33);}.cls-42{clip-path:url(#clippath-35);}.cls-43{clip-path:url(#clippath-36);}.cls-44{clip-path:url(#clippath-39);}.cls-45{clip-path:url(#clippath-37);}.cls-46{clip-path:url(#clippath-29);}.cls-47{clip-path:url(#clippath-26);}.cls-48{clip-path:url(#clippath-28);}.cls-49{clip-path:url(#clippath-27);}.cls-50{clip-path:url(#clippath-38);}.cls-51{clip-path:url(#clippath-31);}.cls-52{clip-path:url(#clippath-60);}.cls-53{clip-path:url(#clippath-69);}.cls-54{clip-path:url(#clippath-76);}.cls-55{clip-path:url(#clippath-71);}.cls-56{clip-path:url(#clippath-78);}.cls-57{clip-path:url(#clippath-74);}.cls-58{clip-path:url(#clippath-77);}.cls-59{clip-path:url(#clippath-75);}.cls-60{clip-path:url(#clippath-72);}.cls-61{clip-path:url(#clippath-70);}.cls-62{clip-path:url(#clippath-66);}.cls-63{clip-path:url(#clippath-58);}.cls-64{clip-path:url(#clippath-57);}.cls-65{clip-path:url(#clippath-52);}.cls-66{clip-path:url(#clippath-51);}.cls-67{clip-path:url(#clippath-55);}.cls-68{clip-path:url(#clippath-56);}.cls-69{clip-path:url(#clippath-50);}.cls-70{clip-path:url(#clippath-54);}.cls-71{clip-path:url(#clippath-53);}.cls-72{clip-path:url(#clippath-65);}.cls-73{clip-path:url(#clippath-63);}.cls-74{clip-path:url(#clippath-59);}.cls-75{clip-path:url(#clippath-73);}.cls-76{clip-path:url(#clippath-67);}.cls-77{clip-path:url(#clippath-61);}.cls-78{clip-path:url(#clippath-64);}.cls-79{clip-path:url(#clippath-68);}.cls-80{clip-path:url(#clippath-62);}.cls-81{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "89.13 42.38 89.26 42.38 89.26 72.11 54.11 89.69 54.11 59.96 54.24 59.83 89.13 42.38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.04 37.86 54.11 59.96 54.11 89.69 10.04 67.59 10.04 37.86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.81 36.7 89.13 42.38 54.24 59.83 71.81 36.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.11 86.46 54.11 92.14 10.04 70.04 10.04 64.36 54.11 86.46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.18,48.33l9.18,4.52v11.5l-9.18-4.52v-11.5Zm-1.68-2.97v15.77l12.54,6.2v-15.77l-12.54-6.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.56 44.32 16.5 45.36 16.5 61.25 14.56 62.68 14.56 44.32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.5 61.25 16.5 61.25 29.04 67.46 29.04 69.91 14.56 62.68 16.5 61.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.18 59.96 27.35 64.48 27.35 52.98 18.18 48.33 18.18 59.96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.79 48.2 18.95 48.72 18.95 59.44 17.79 60.22 17.79 48.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.95 59.44 18.95 59.44 27.35 63.58 27.35 65 17.79 60.22 18.95 59.44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "89.26 68.88 89.26 74.69 54.11 92.14 54.11 86.46 89.26 68.88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.89 84 69.1 78.96 69.1 56.73 58.89 61.77 58.89 84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.17 55.7 71.17 78.83 69.1 77.93 69.1 56.73 71.17 55.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.28,64.1l-5.69,2.84v-11.5l5.69-2.84v11.5Zm-7.5-10.08v15.77l9.05-4.52v-15.77l-9.05,4.52Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86.03 48.59 83.96 49.62 83.96 65.39 86.03 66.81 86.03 48.59"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.96 65.39 83.96 65.39 74.79 69.91 74.79 72.37 86.03 66.81 83.96 65.39"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "82.28 64.1 76.6 66.94 76.6 55.31 82.28 52.59 82.28 64.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "82.67 52.34 81.51 52.85 81.51 63.58 82.67 64.36 82.67 52.34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.51 63.58 81.51 63.58 76.6 66.04 76.6 67.33 82.67 64.36 81.51 63.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.18,72.11c0,.65.39,1.03,1.03.78.52-.26,1.03-1.03,1.03-1.68s-.39-1.03-1.03-.78c-.52.26-1.03,1.03-1.03,1.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.83,72.37c0,.65.39,1.03,1.03.78.52-.26,1.03-1.03,1.03-1.68s-.39-1.03-1.03-.78c-.65.26-1.03,1.03-1.03,1.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.34,58.54l9.05,4.52v11.37l-9.05-4.52v-11.37Zm-1.68-2.84v15.64l12.41,6.2v-15.64l-12.41-6.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.59 54.66 36.66 55.7 36.66 71.21 34.59 72.63 34.59 54.66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.66 71.21 36.66 71.21 49.07 77.41 49.07 79.86 34.59 72.76 34.59 72.63 36.66 71.21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.34 69.91 47.39 74.44 47.39 63.06 38.34 58.54 38.34 69.91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.95 58.41 38.99 58.93 38.99 69.53 37.95 70.3 37.95 58.41"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.99 69.53 38.99 69.53 47.39 73.66 47.39 74.95 37.95 70.3 38.99 69.53"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.89 82.84 69.1 78.06 71.17 78.83 58.89 84.9 58.89 82.84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "67.68 91.88 79.96 85.68 76.85 84.13 64.71 90.33 67.68 91.88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "64.71 90.33 76.85 84.13 76.85 81.8 64.71 88.01 64.71 90.33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "67.68 94.47 79.96 88.27 79.96 85.68 67.68 91.88 67.68 94.47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.17 78.83 76.85 81.8 64.71 88.01 58.89 84.9 71.17 78.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.89 89.82 67.68 94.47 67.68 91.88 64.71 90.33 64.71 88.01 58.89 84.9 58.89 89.82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "94.56 44.45 74.66 38.12 27.48 14.73 50.1 22.48 94.56 44.45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "6.55 41.74 50.88 63.84 74.66 38.12 27.48 14.73 6.55 41.74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.88 65.26 50.88 63.84 6.55 41.74 6.55 42.77 50.88 65.26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.88 65.26 50.88 63.84 74.66 38.12 94.56 44.45 94.56 45.36 75.04 39.15 50.88 65.26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.24 20.8 31.36 18.86 31.36 24.68 35.24 26.62 35.24 20.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.06 30.36 31.36 24.68 31.36 18.86 26.06 21.58 26.06 30.36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.36,18.86l-5.3,2.71,3.88,1.94,5.3-2.71-3.88-1.94Zm0,.78l2.46,1.16-3.88,1.94-2.46-1.16,3.88-1.94Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.94 32.3 26.06 30.36 26.06 21.58 29.94 23.52 29.94 32.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.94 32.3 35.24 26.62 35.24 20.8 29.94 23.52 29.94 32.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.66,81.92l.78.45c1.21.7,1.96,2.19,1.97,4.31.01,4.27-3.01,9.49-6.72,11.64l-.78-.45c3.71-2.14,6.73-7.36,6.72-11.64,0-2.12-.76-3.61-1.97-4.31Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.89,98.79l-.78-.45c1.23.71,2.92.61,4.79-.47l.78.45c-1.87,1.08-3.57,1.18-4.79.47Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.48,99.5l-.78-.45c-1.32-.76-2.13-2.39-2.14-4.7-.01-4.64,3.27-10.32,7.3-12.65l.78.45c-4.04,2.33-7.32,8.01-7.3,12.65,0,2.31.82,3.93,2.14,4.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.07,81.2l.78.45c-1.33-.77-3.18-.67-5.21.5l-.78-.45c2.03-1.17,3.88-1.28,5.21-.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.56,11.55l-.78-.45c.19.11.43.1.69-.05l.78.45c-.26.15-.5.16-.69.05Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.24,1.22l.78.45c1.21.7,1.96,2.19,1.97,4.31.01,4.27-3.01,9.49-6.72,11.64l-.78-.45c3.71-2.14,6.73-7.36,6.72-11.64,0-2.12-.76-3.61-1.97-4.31Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.47,18.08l-.78-.45c1.23.71,2.92.61,4.79-.47l.78.45c-1.87,1.08-3.57,1.18-4.79.47Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m51.15,7.66l.78.45c.26.15.43.53.44,1.07,0,.92-.5,1.96-1.12,2.32l-.78-.45c.62-.36,1.12-1.39,1.12-2.32,0-.54-.17-.92-.44-1.07Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.25,6.69l.78.45c-1.29-.75-2.56-.54-3.7.12l-.78-.45c1.14-.66,2.41-.87,3.7-.12Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.08,12.7l-.78-.45c-.09-.05-.17-.1-.26-.16l.78.45c.09.06.17.11.26.16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.83,12.54l-.78-.45c.1-.19,1.91-3.79,4.5-5.29l.78.45c-2.59,1.49-4.4,5.1-4.5,5.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.06,18.8l-.78-.45c-1.32-.76-2.13-2.39-2.14-4.7-.01-4.64,3.27-10.32,7.3-12.65l.78.45c-4.04,2.33-7.32,8.01-7.3,12.65,0,2.31.82,3.93,2.14,4.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.65.5l.78.45c-1.33-.77-3.18-.67-5.21.5l-.78-.45c2.03-1.17,3.88-1.28,5.21-.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.16,19.91l-.78-.45s-.01,0-.02-.01c-.07-.05-.13-.09-.2-.13l.78.45c.06.04.13.08.2.13,0,0,.01,0,.02.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81.45,15.58l-.78-.45c1.21-.7,2.57-.93,3.84-.19l.78.45c-1.27-.73-2.63-.5-3.84.19Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.52 14.94 85.3 15.39 85.29 15.39 84.51 14.93 84.52 14.94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81.16,21.41l.78.45c-.15-.09-.36-.07-.58.06l-.78-.45c.23-.13.43-.14.58-.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.77,23.86l-.78-.45c-.15-.09-.24-.27-.24-.53,0-.52.37-1.16.82-1.42l.78.45c-.45.26-.82.9-.82,1.42,0,.26.09.44.24.53Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m76.52,27.88l-.78-.45c1.23.71,2.92.61,4.79-.47l.78.45c-1.87,1.08-3.57,1.18-4.79.47Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.28,11.01l.78.45c1.21.7,1.96,2.2,1.97,4.32.01,4.27-3,9.49-6.71,11.63l-.78-.45c3.71-2.14,6.72-7.37,6.71-11.63,0-2.12-.76-3.62-1.97-4.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.75,18.28l.78.45c-.7-.41-1.46-.3-2.15.09l-.78-.45c.68-.39,1.44-.5,2.15-.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.79,21.78l-.78-.45s.27-.53.72-1.15c.44-.61,1.08-1.36,1.85-1.8l.78.45c-.77.44-1.41,1.19-1.85,1.8-.44.61-.7,1.11-.72,1.15Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81.37,18.83l-.78-.45s.01,0,.02-.01l.78.45s-.01,0-.02.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.82,22.43l-.78-.45c-.16-.09-.17-.37-.02-.65l.78.45c-.15.28-.13.56.02.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.26,20.91l-.78-.45c-.21-.12-.21-.52,0-.89.02-.04.46-.78,1.19-1.7.73-.91,1.75-2.02,2.97-2.72l.78.45c-1.21.7-2.24,1.81-2.97,2.72-.73.92-1.17,1.67-1.19,1.7-.21.37-.22.77,0,.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81.43,15.6l-.78-.45s.02-.01.03-.02l.78.45s-.02.01-.03.02Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "77.27 20.91 76.49 20.46 76.49 20.45 77.26 20.91 77.27 20.91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m76.1,28.6l-.78-.45c-1.32-.76-2.13-2.39-2.14-4.7-.01-4.65,3.26-10.31,7.3-12.65l.78.45c-4.04,2.33-7.32,8-7.3,12.65,0,2.31.82,3.93,2.14,4.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.7,10.29l.78.45c-1.33-.77-3.18-.67-5.21.51l-.78-.45c2.03-1.17,3.88-1.28,5.21-.51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.71,17.33l-.78-.45c.13.08.45-.03.47-.04l.78.45s-.34.12-.47.04Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.4,5.25l.78.45c1.21.7,1.96,2.2,1.97,4.32.01,4.27-3,9.48-6.72,11.63l-.78-.45c3.72-2.15,6.73-7.36,6.72-11.63,0-2.12-.76-3.62-1.97-4.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.64,22.12l-.78-.45c1.23.71,2.93.61,4.8-.47l.78.45c-1.87,1.08-3.57,1.18-4.8.47Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.23,9.54l.78.45c.15.09.25.28.25.55,0,.54-.39,1.21-.86,1.49l-.78-.45c.47-.27.86-.94.86-1.49,0-.27-.1-.46-.25-.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.79,12.09l-.78-.45c.16.09.37.08.61-.06l.78.45c-.24.14-.45.15-.61.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.51,15.11l-.78-.45c-.48-.28-.78-.87-.78-1.72,0-1.69,1.19-3.77,2.67-4.62.74-.43,1.42-.47,1.9-.19l.78.45c-.49-.28-1.16-.24-1.9.19-1.48.85-2.67,2.92-2.67,4.62,0,.84.3,1.44.78,1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.82,4.54l.78.45c-1.33-.77-3.18-.67-5.21.51l-.78-.45c2.03-1.17,3.88-1.28,5.21-.51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.22,22.84l-.78-.45c-1.32-.76-2.13-2.39-2.14-4.69-.01-4.65,3.27-10.32,7.3-12.65l.78.45c-4.04,2.33-7.32,8-7.3,12.65,0,2.3.82,3.93,2.14,4.69Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_automation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "House_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m50.38,94.41l36.48-18.95c1.13-.67,1.13-2.3,0-2.96l-44-23.19c-.54-.32-1.21-.31-1.74,0L6.97,69.73c-1.11.66-1.13,2.26-.02,2.94l41.67,21.72c.54.33,1.22.34,1.77.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 47.65,
    y: 35.92,
    width: 48.08,
    height: 60.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 3.57,
    y: 31.4,
    width: 57,
    height: 64.75
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 47.78,
    y: 30.24,
    width: 47.82,
    height: 36.06
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 3.57,
    y: 57.89,
    width: 57,
    height: 40.71
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 10.04,
    y: 38.89,
    width: 25.46,
    height: 34.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 8.1,
    y: 37.86,
    width: 14.86,
    height: 31.28
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 8.1,
    y: 54.79,
    width: 27.4,
    height: 21.58
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 11.72,
    y: 41.87,
    width: 22.1,
    height: 29.08
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 11.33,
    y: 41.74,
    width: 14.09,
    height: 24.94
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 11.33,
    y: 52.98,
    width: 22.49,
    height: 18.48
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 47.65,
    y: 62.42,
    width: 48.08,
    height: 36.19
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 52.43,
    y: 50.27,
    width: 23.13,
    height: 40.19
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 62.64,
    y: 49.23,
    width: 14.99,
    height: 36.06
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 68.32,
    y: 43.03,
    width: 21.97,
    height: 33.22
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 77.5,
    y: 42.13,
    width: 14.99,
    height: 31.15
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 68.32,
    y: 58.93,
    width: 24.17,
    height: 19.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 70.13,
    y: 46.13,
    width: 18.61,
    height: 27.27
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 75.04,
    y: 45.87,
    width: 14.09,
    height: 24.94
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 70.13,
    y: 57.12,
    width: 19,
    height: 16.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 53.72,
    y: 63.89,
    width: 14.99,
    height: 15.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 54.37,
    y: 64.15,
    width: 14.99,
    height: 15.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 30.2,
    y: 49.23,
    width: 25.33,
    height: 34.77
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 28.13,
    y: 48.2,
    width: 14.99,
    height: 30.89
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 28.13,
    y: 64.74,
    width: 27.4,
    height: 21.58
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 31.88,
    y: 52.08,
    width: 21.97,
    height: 28.82
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 31.49,
    y: 51.95,
    width: 13.96,
    height: 24.81
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 31.49,
    y: 63.06,
    width: 22.36,
    height: 18.35
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 52.43,
    y: 71.59,
    width: 25.2,
    height: 19.77
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 58.24,
    y: 77.67,
    width: 28.17,
    height: 20.68
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 58.24,
    y: 75.34,
    width: 25.07,
    height: 21.45
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 61.22,
    y: 79.22,
    width: 25.2,
    height: 21.71
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 52.43,
    y: 72.37,
    width: 30.89,
    height: 22.1
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 52.43,
    y: 78.44,
    width: 21.71,
    height: 22.49
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "94.56 44.45 74.66 38.12 27.48 14.73 50.1 22.48 94.56 44.45"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 21.02,
    y: 8.26,
    width: 80,
    height: 42.65
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "6.55 41.74 50.88 63.84 74.66 38.12 27.48 14.73 6.55 41.74"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 0.08,
    y: 8.26,
    width: 81.03,
    height: 62.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 0.08,
    y: 35.28,
    width: 57.25,
    height: 36.45
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 44.41,
    y: 31.66,
    width: 56.61,
    height: 40.06
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 24.9,
    y: 12.4,
    width: 16.8,
    height: 20.68
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 19.6,
    y: 12.4,
    width: 18.22,
    height: 24.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 19.6,
    y: 12.4,
    width: 22.1,
    height: 17.58
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 19.6,
    y: 15.11,
    width: 16.8,
    height: 23.65
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 23.48,
    y: 14.34,
    width: 18.22,
    height: 24.43
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "15.39 89.63 14.61 89.18 16.41 88.14 17.19 88.59 15.39 89.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "14.11 96.32 13.33 95.87 13.69 90.52 14.47 90.98 14.11 96.32"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m14.69,98.32l-.78-.45c.79-.45,1.54-1.05,2.25-1.74l.78.45c-.7.69-1.46,1.29-2.25,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m16.93,96.59l-.78-.45c.25-.25.5-.51.74-.78l.78.45c-.24.27-.48.54-.74.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m17.67,95.8l-.78-.45c.19-.22.37-.44.55-.67l.78.45c-.18.23-.36.45-.55.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m18.22,95.13l-.78-.45c.15-.2.3-.4.45-.61l.78.45c-.15.21-.3.41-.45.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m18.67,94.52l-.78-.45c.13-.19.26-.39.39-.58l.78.45c-.13.2-.26.39-.39.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m19.06,93.94l-.78-.45c.12-.19.24-.38.35-.57l.78.45c-.11.19-.23.38-.35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m19.41,93.37l-.78-.45c.11-.19.22-.38.32-.57l.78.45c-.1.19-.21.38-.32.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m19.73,92.8l-.78-.45c.1-.19.2-.38.29-.57l.78.45c-.09.19-.19.38-.29.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m20.02,92.22l-.78-.45c.09-.19.18-.39.27-.59l.78.45c-.09.2-.17.39-.27.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m20.29,91.64l-.78-.45c.09-.2.17-.4.25-.61l.78.45c-.08.2-.16.4-.25.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m20.53,91.03l-.78-.45c.08-.21.16-.42.23-.64l.78.45c-.07.21-.15.43-.23.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m20.76,90.39l-.78-.45c.08-.23.15-.46.21-.69l.78.45c-.06.23-.13.46-.21.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m20.97,89.71l-.78-.45c.07-.26.13-.52.19-.77l.78.45c-.05.26-.12.51-.19.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m21.16,88.93l-.78-.45c.07-.31.12-.62.16-.93l.78.45c-.04.31-.09.62-.16.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m21.32,88l-.78-.45c.06-.44.09-.88.09-1.31,0-2.12-.76-3.61-1.97-4.31l.78.45c1.21.7,1.96,2.19,1.97,4.31,0,.43-.03.87-.09,1.31"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m9.89,98.79l-.78-.45s.02.01.04.02l.78.45s-.02-.01-.04-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m9.93,98.81l-.78-.45c.11.06.22.12.34.17l.78.45c-.12-.05-.23-.1-.34-.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m10.27,98.98l-.78-.45c.12.05.23.09.36.13l.78.45c-.12-.04-.24-.08-.36-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m10.63,99.1l-.78-.45c.12.04.25.07.38.09l.78.45c-.13-.02-.26-.05-.38-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m11.01,99.19l-.78-.45c.13.02.27.04.41.05l.78.45c-.14,0-.28-.02-.41-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m11.42,99.24l-.78-.45c.15,0,.29.01.45,0l.78.45c-.15,0-.3,0-.45,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m11.86,99.24l-.78-.45c.16,0,.33-.02.5-.05l.78.45c-.17.03-.34.04-.5.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m12.36,99.19l-.78-.45c.19-.03.39-.07.59-.13l.78.45c-.2.05-.4.1-.59.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m12.96,99.06l-.78-.45c.26-.07.52-.16.79-.27l.78.45c-.27.11-.53.2-.79.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m13.75,98.79l-.78-.45c.31-.13.62-.28.94-.47l.78.45c-.32.18-.63.34-.94.47"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "12.68 92.01 11.9 91.56 12.74 85.94 13.52 86.39 12.68 92.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "13.52 86.39 12.74 85.94 15.81 84.17 16.59 84.62 13.52 86.39"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m9.48,99.5l-.78-.45c-1.32-.76-2.13-2.39-2.14-4.7,0-.47.03-.94.09-1.43l.78.45c-.06.48-.09.96-.09,1.43,0,2.31.82,3.93,2.14,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m7.43,93.38l-.78-.45c.04-.34.1-.67.17-1.01l.78.45c-.07.34-.13.68-.17,1.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m7.61,92.37l-.78-.45c.06-.28.13-.56.21-.84l.78.45c-.08.28-.15.56-.21.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m7.81,91.53l-.78-.45c.07-.25.15-.5.23-.75l.78.45c-.08.25-.16.5-.23.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m8.04,90.78l-.78-.45c.08-.23.16-.46.25-.69l.78.45c-.09.23-.17.46-.25.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m8.29,90.09l-.78-.45c.08-.22.17-.44.27-.66l.78.45c-.09.22-.18.44-.27.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m8.56,89.43l-.78-.45c.09-.21.19-.43.29-.64l.78.45c-.1.21-.2.42-.29.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m8.85,88.79l-.78-.45c.1-.21.21-.42.32-.63l.78.45c-.11.21-.22.42-.32.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m9.17,88.17l-.78-.45c.11-.21.23-.42.35-.62l.78.45c-.12.2-.23.41-.35.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m9.51,87.55l-.78-.45c.12-.21.25-.42.38-.62l.78.45c-.13.2-.26.41-.38.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m9.89,86.93l-.78-.45c.14-.22.28-.43.43-.64l.78.45c-.15.21-.29.42-.43.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m10.32,86.29l-.78-.45c.16-.23.32-.45.49-.66l.78.45c-.17.22-.33.44-.49.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m10.81,85.63l-.78-.45c.19-.25.39-.49.6-.73l.78.45c-.2.23-.4.48-.6.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m11.4,84.9l-.78-.45c.26-.3.53-.58.8-.85l.78.45c-.27.27-.54.56-.8.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m12.2,84.05l-.78-.45c.76-.75,1.58-1.4,2.44-1.89l.78.45c-.85.49-1.68,1.14-2.44,1.89"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m14.64,82.16c4.04-2.33,7.34-.45,7.35,4.19s-3.27,10.32-7.3,12.65-7.34.46-7.35-4.19,3.27-10.32,7.3-12.65Zm.05,16.16c3.71-2.14,6.73-7.36,6.72-11.64-.01-4.27-3.05-5.99-6.76-3.85s-6.73,7.36-6.72,11.63c.01,4.27,3.05,6,6.76,3.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "16.59 84.62 15.39 89.63 17.19 88.59 14.11 96.32 14.47 90.98 12.68 92.01 13.52 86.39 16.59 84.62"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m14.64,82.16l-.78-.45c.35-.2.69-.37,1.02-.51l.78.45c-.33.14-.67.31-1.02.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m15.66,81.65l-.78-.45c.29-.12.58-.22.86-.3l.78.45c-.28.08-.57.17-.86.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m16.52,81.36l-.78-.45c.22-.06.43-.11.64-.14l.78.45c-.21.03-.42.08-.64.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m17.17,81.22l-.78-.45c.19-.03.37-.05.55-.05l.78.45c-.18,0-.36.03-.55.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m17.71,81.17l-.78-.45c.17,0,.33,0,.49,0l.78.45c-.16,0-.32-.01-.49,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m18.2,81.17l-.78-.45c.15,0,.3.03.44.05l.78.45c-.14-.03-.29-.04-.44-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m18.64,81.22l-.78-.45c.14.02.28.06.41.1l.78.45c-.13-.04-.27-.07-.41-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m19.05,81.32l-.78-.45c.13.04.26.08.39.14l.78.45c-.13-.05-.26-.1-.39-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m19.44,81.45l-.78-.45c.13.05.25.11.37.18l.78.45c-.12-.07-.24-.13-.37-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m19.81,81.63l-.78-.45s.03.02.04.02l.78.45s-.03-.02-.04-.02"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "14.89 66.32 14.93 79.16 14.34 79.5 14.3 66.66 14.89 66.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "14.34 79.5 13.56 79.05 13.52 66.21 14.3 66.66 14.34 79.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "14.3 66.66 13.52 66.21 14.12 65.87 14.89 66.32 14.3 66.66"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "51.57 19.85 51.61 32.7 51.01 33.04 50.98 20.2 51.57 19.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "51.01 33.04 50.23 32.59 50.2 19.74 50.98 20.2 51.01 33.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "50.98 20.2 50.2 19.74 50.79 19.4 51.57 19.85 50.98 20.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-106",
    points: "50.56 11.55 49.78 11.1 49.79 11.1 50.56 11.55 50.56 11.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m50.56,11.55l-.78-.45s.04.02.06.03l.78.45s-.04-.02-.06-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m50.62,11.58l-.78-.45s.04.02.06.02l.78.45s-.04-.01-.06-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m50.68,11.6l-.78-.45s.04.01.06.01l.78.45s-.04,0-.06-.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m50.74,11.62l-.78-.45s.04,0,.06,0l.78.45s-.04,0-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m50.8,11.62l-.78-.45s.04,0,.07,0l.78.45s-.04,0-.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m50.87,11.62l-.78-.45s.05,0,.07,0l.78.45s-.05,0-.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m50.94,11.62l-.78-.45s.05,0,.08-.02l.78.45s-.05.01-.08.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m51.02,11.6l-.78-.45s.07-.02.11-.04l.78.45s-.07.03-.11.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m51.13,11.56l-.78-.45s.08-.04.12-.06l.78.45s-.08.04-.12.06"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m51.27,17.62l-.78-.45c.79-.45,1.54-1.05,2.24-1.74l.78.45c-.7.69-1.46,1.29-2.24,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m53.51,15.88l-.78-.45c.25-.25.5-.51.74-.78l.78.45c-.24.27-.48.54-.74.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m54.25,15.09l-.78-.45c.19-.22.37-.44.55-.67l.78.45c-.18.23-.36.45-.55.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m54.8,14.43l-.78-.45c.15-.2.3-.4.45-.61l.78.45c-.15.21-.3.41-.45.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m55.25,13.82l-.78-.45c.13-.19.26-.39.39-.58l.78.45c-.13.2-.26.39-.39.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m55.64,13.23l-.78-.45c.12-.19.24-.38.35-.57l.78.45c-.11.19-.23.38-.35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m55.99,12.66l-.78-.45c.11-.19.22-.38.32-.57l.78.45c-.1.19-.21.38-.32.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m56.3,12.09l-.78-.45c.1-.19.2-.38.29-.57l.78.45c-.09.19-.19.38-.29.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m56.6,11.51l-.78-.45c.09-.19.18-.39.27-.59l.78.45c-.09.2-.17.39-.27.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m56.86,10.93l-.78-.45c.09-.2.17-.4.25-.61l.78.45c-.08.2-.16.4-.25.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m57.11,10.32l-.78-.45c.08-.21.16-.42.23-.64l.78.45c-.07.21-.15.43-.23.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m57.34,9.69l-.78-.45c.08-.23.15-.46.21-.69l.78.45c-.06.23-.13.46-.21.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m57.55,9l-.78-.45c.07-.26.13-.52.19-.77l.78.45c-.05.26-.12.51-.19.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m57.74,8.23l-.78-.45c.07-.31.12-.62.16-.93l.78.45c-.04.31-.09.62-.16.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m57.9,7.29l-.78-.45c.06-.44.09-.88.09-1.31,0-2.12-.76-3.61-1.97-4.31l.78.45c1.21.7,1.96,2.19,1.97,4.31,0,.43-.03.87-.09,1.31"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m46.47,18.08l-.78-.45s.02.01.04.02l.78.45s-.02-.01-.04-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m46.51,18.1l-.78-.45c.11.06.22.12.34.17l.78.45c-.12-.05-.23-.1-.34-.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m46.85,18.27l-.78-.45c.12.05.23.09.36.13l.78.45c-.12-.04-.24-.08-.36-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m47.21,18.39l-.78-.45c.12.04.25.07.38.09l.78.45c-.13-.02-.26-.05-.38-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m47.59,18.48l-.78-.45c.13.02.27.04.41.05l.78.45c-.14,0-.28-.02-.41-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m47.99,18.53l-.78-.45c.15,0,.29.01.45,0l.78.45c-.15,0-.3,0-.45,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m48.44,18.53l-.78-.45c.16,0,.33-.02.5-.05l.78.45c-.17.03-.34.04-.5.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m48.94,18.48l-.78-.45c.19-.03.39-.07.59-.13l.78.45c-.2.05-.4.1-.59.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m49.54,18.36l-.78-.45c.26-.07.52-.16.79-.27l.78.45c-.27.11-.53.2-.79.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m50.33,18.08l-.78-.45c.31-.13.62-.28.94-.47l.78.45c-.32.18-.63.34-.94.47"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m51.25,11.5l-.78-.45c.1-.06.2-.14.3-.23l.78.45c-.09.09-.19.17-.3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m51.55,11.27l-.78-.45s.07-.07.1-.11l.78.45s-.07.08-.1.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m51.65,11.16l-.78-.45s.05-.06.08-.1l.78.45s-.05.07-.08.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m51.73,11.06l-.78-.45s.05-.06.07-.1l.78.45s-.05.06-.07.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m51.8,10.97l-.78-.45s.04-.06.06-.1l.78.45s-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m51.87,10.87l-.78-.45s.04-.07.06-.1l.78.45s-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m51.93,10.77l-.78-.45s.04-.07.06-.1l.78.45s-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m51.99,10.67l-.78-.45s.04-.07.06-.11l.78.45s-.04.07-.06.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m52.04,10.56l-.78-.45s.04-.08.05-.12l.78.45s-.04.08-.05.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m52.1,10.44l-.78-.45s.04-.09.05-.13l.78.45s-.03.09-.05.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m52.15,10.31l-.78-.45s.04-.1.05-.14l.78.45s-.03.1-.05.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m52.2,10.16l-.78-.45c.02-.05.04-.11.05-.17l.78.45c-.02.06-.03.11-.05.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m52.25,10l-.78-.45c.02-.06.03-.13.05-.2l.78.45c-.01.07-.03.13-.05.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m52.3,9.8l-.78-.45c.02-.08.03-.17.04-.25l.78.45c-.01.08-.03.17-.04.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m52.34,9.55l-.78-.45c.02-.12.02-.24.02-.36,0-.54-.17-.92-.44-1.07l.78.45c.26.15.43.53.44,1.07,0,.12,0,.24-.02.36"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m51.33,7.26l-.78-.45c.2-.11.4-.21.6-.3l.78.45c-.2.08-.4.18-.6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m51.93,6.96l-.78-.45c.17-.07.33-.13.5-.17l.78.45c-.17.05-.34.1-.5.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m52.43,6.79l-.78-.45c.13-.04.27-.06.4-.09l.78.45c-.13.02-.27.05-.4.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m52.83,6.7l-.78-.45c.12-.02.24-.03.36-.04l.78.45c-.12,0-.24.02-.36.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m53.19,6.67l-.78-.45c.11,0,.23,0,.34,0l.78.45c-.11,0-.23,0-.34,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m53.53,6.67l-.78-.45c.11,0,.23.02.34.04l.78.45c-.11-.02-.23-.03-.34-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m53.87,6.71l-.78-.45c.12.02.23.05.35.08l.78.45c-.12-.03-.23-.06-.35-.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m54.22,6.79l-.78-.45c.12.04.24.08.37.13l.78.45c-.12-.05-.24-.09-.37-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m54.59,6.92l-.78-.45c.13.06.26.12.4.19l.78.45c-.13-.07-.26-.14-.4-.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m54.98,7.11l-.78-.45s.03.02.05.03l.78.45s-.03-.02-.05-.03"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m47.08,12.7l-.78-.45c-.09-.05-.17-.1-.26-.16l.78.45c.09.06.17.11.26.16"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m46.83,12.54l-.78-.45s.05-.09.1-.2l.78.45c-.06.11-.09.18-.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m46.93,12.35l-.78-.45c.07-.13.18-.33.31-.56l.78.45c-.14.23-.24.43-.31.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m47.24,11.79l-.78-.45c.11-.19.25-.41.4-.65l.78.45c-.15.24-.29.46-.4.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m47.64,11.13l-.78-.45c.13-.21.28-.43.44-.66l.78.45c-.16.23-.31.45-.44.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m48.08,10.48l-.78-.45c.15-.21.3-.42.47-.64l.78.45c-.17.22-.33.43-.47.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m48.55,9.83l-.78-.45c.16-.21.34-.42.52-.64l.78.45c-.18.21-.36.42-.52.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m49.08,9.2l-.78-.45c.2-.23.41-.46.63-.68l.78.45c-.22.22-.43.45-.63.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m49.71,8.52l-.78-.45c.49-.49,1.04-.93,1.62-1.27l.78.45c-.58.34-1.13.78-1.62,1.27"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m46.06,18.8l-.78-.45c-1.32-.76-2.13-2.39-2.14-4.7,0-.47.03-.94.09-1.43l.78.45c-.06.48-.09.96-.09,1.43,0,2.31.82,3.93,2.14,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m44.01,12.67l-.78-.45c.04-.34.1-.67.17-1.01l.78.45c-.07.34-.13.68-.17,1.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m44.19,11.66l-.78-.45c.06-.28.13-.56.21-.84l.78.45c-.08.28-.15.56-.21.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m44.39,10.82l-.78-.45c.07-.25.15-.5.23-.75l.78.45c-.08.25-.16.5-.23.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m44.62,10.08l-.78-.45c.08-.23.16-.46.25-.69l.78.45c-.09.23-.17.46-.25.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m44.87,9.38l-.78-.45c.08-.22.17-.44.27-.66l.78.45c-.09.22-.18.44-.27.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m45.14,8.72l-.78-.45c.09-.21.19-.43.29-.64l.78.45c-.1.21-.2.42-.29.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m45.43,8.09l-.78-.45c.1-.21.21-.42.32-.63l.78.45c-.11.21-.22.42-.32.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m45.75,7.46l-.78-.45c.11-.21.23-.42.35-.62l.78.45c-.12.2-.23.41-.35.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m46.09,6.84l-.78-.45c.12-.21.25-.42.38-.62l.78.45c-.13.2-.26.41-.38.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m46.47,6.22l-.78-.45c.14-.22.28-.43.43-.64l.78.45c-.15.21-.29.42-.43.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m46.9,5.58l-.78-.45c.16-.23.32-.45.49-.66l.78.45c-.17.22-.33.44-.49.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m47.39,4.92l-.78-.45c.19-.25.39-.49.6-.73l.78.45c-.2.23-.4.48-.6.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m47.98,4.2l-.78-.45c.26-.3.53-.58.8-.85l.78.45c-.27.27-.54.56-.8.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m48.78,3.34l-.78-.45c.76-.75,1.58-1.4,2.44-1.89l.78.45c-.85.49-1.68,1.14-2.44,1.89"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m51.22,1.45c4.04-2.33,7.34-.45,7.35,4.19s-3.27,10.32-7.3,12.65-7.34.46-7.35-4.19,3.27-10.32,7.3-12.65Zm.05,16.16c3.71-2.14,6.73-7.36,6.72-11.64S54.94,0,51.22,2.13s-6.73,7.36-6.72,11.63c.01,4.27,3.05,6,6.76,3.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m51.33,7.26c1.29-.75,2.76-.92,4.23.25-.09.18-1.7,3.67-4.29,5.17-1.29.75-2.81.95-4.44-.13.1-.19,1.91-3.79,4.5-5.29Zm-.08,4.24c.62-.36,1.12-1.39,1.12-2.32s-.51-1.38-1.13-1.02-1.12,1.39-1.12,2.32.51,1.38,1.13,1.02"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m51.22,1.45l-.78-.45c.35-.2.69-.37,1.02-.51l.78.45c-.33.14-.67.31-1.02.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m52.24.95l-.78-.45c.29-.12.58-.22.86-.3l.78.45c-.28.08-.57.17-.86.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m53.1.65l-.78-.45c.22-.06.43-.11.64-.14l.78.45c-.21.03-.42.08-.64.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m53.74.51l-.78-.45c.19-.03.37-.05.55-.05l.78.45c-.18,0-.36.03-.55.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m54.29.46l-.78-.45c.17,0,.33,0,.49,0l.78.45c-.16,0-.32-.01-.49,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m54.78.46l-.78-.45c.15,0,.3.03.44.05l.78.45c-.14-.03-.29-.04-.44-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m55.22.51l-.78-.45c.14.02.28.06.41.1l.78.45c-.13-.04-.27-.07-.41-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m55.63.61l-.78-.45c.13.04.26.08.39.14l.78.45c-.13-.05-.26-.1-.39-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m56.02.75l-.78-.45c.13.05.25.11.37.18l.78.45c-.12-.07-.24-.13-.37-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m56.39.93l-.78-.45s.03.02.04.02l.78.45s-.03-.02-.04-.02"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "81.61 29.66 81.65 42.5 81.06 42.84 81.02 30 81.61 29.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "81.06 42.84 80.28 42.39 80.24 29.54 81.02 30 81.06 42.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "81.02 30 80.24 29.54 80.83 29.21 81.61 29.66 81.02 30"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m83.16,19.91l-.78-.45s-.01,0-.02-.01c-.07-.05-.13-.09-.2-.13l.78.45c.06.04.13.08.2.13,0,0,.01,0,.02.01"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m81.45,15.58l-.78-.45c.21-.12.43-.23.64-.32l.78.45c-.22.09-.43.2-.64.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m82.1,15.26l-.78-.45c.18-.08.37-.14.56-.19l.78.45c-.19.05-.37.11-.56.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m82.65,15.07l-.78-.45c.15-.04.29-.07.44-.09l.78.45c-.15.02-.29.05-.44.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m83.09,14.98l-.78-.45c.13-.02.26-.03.39-.04l.78.45c-.13,0-.26.02-.39.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m83.48,14.94l-.78-.45c.12,0,.24,0,.36,0l.78.45c-.12,0-.24,0-.36,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m83.84,14.94l-.78-.45c.12,0,.23.02.35.04l.78.45c-.12-.02-.23-.03-.35-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m84.19,14.98l-.78-.45c.12.02.23.05.35.08l.78.45c-.12-.03-.23-.06-.35-.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m84.54,15.06l-.78-.45c.12.03.24.08.35.13l.78.45c-.12-.05-.24-.09-.35-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m84.9,15.19l-.78-.45c.12.05.25.11.37.18l.78.45c-.12-.07-.24-.13-.37-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m85.26,15.37l-.78-.45s.02.01.03.02l.78.45s-.02-.01-.03-.02"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-106",
    points: "85.29 15.39 84.51 14.93 84.52 14.94 85.3 15.39 85.29 15.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-106",
    points: "85.3 15.39 84.52 14.94 84.52 14.94 85.3 15.39 85.3 15.39"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m81.35,21.92l-.78-.45s.08-.04.11-.06l.78.45s-.08.03-.11.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m81.47,21.86l-.78-.45s.06-.02.1-.03l.78.45s-.06.02-.1.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m81.56,21.83l-.78-.45s.05-.01.07-.02l.78.45s-.05,0-.07.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m81.64,21.81l-.78-.45s.04,0,.06,0l.78.45s-.04,0-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m81.7,21.81l-.78-.45s.04,0,.05,0l.78.45s-.04,0-.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m81.75,21.81l-.78-.45s.03,0,.05,0l.78.45s-.03,0-.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m81.8,21.81l-.78-.45s.03,0,.05.01l.78.45s-.03,0-.05-.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m81.85,21.82l-.78-.45s.03,0,.04.02l.78.45s-.03-.01-.04-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m81.89,21.84l-.78-.45s.03.01.04.02l.78.45s-.03-.01-.04-.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-106",
    points: "81.93 21.86 81.15 21.41 81.16 21.41 81.94 21.86 81.93 21.86"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m80.77,23.86l-.78-.45c-.15-.09-.24-.27-.24-.53,0-.05,0-.1.01-.16l.78.45c0,.05-.01.11-.01.16,0,.26.09.44.24.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m80.54,23.18l-.78-.45s.01-.07.02-.11l.78.45s-.01.07-.02.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m80.56,23.07l-.78-.45s.01-.06.02-.09l.78.45s-.02.06-.02.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m80.58,22.97l-.78-.45s.02-.06.03-.08l.78.45s-.02.06-.03.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m80.61,22.89l-.78-.45s.02-.05.03-.08l.78.45s-.02.05-.03.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m80.64,22.81l-.78-.45s.02-.05.03-.07l.78.45s-.02.05-.03.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m80.67,22.74l-.78-.45s.02-.05.03-.07l.78.45s-.02.05-.03.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m80.7,22.67l-.78-.45s.02-.05.04-.07l.78.45s-.02.05-.04.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m80.73,22.6l-.78-.45s.03-.05.04-.07l.78.45s-.03.05-.04.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m80.77,22.53l-.78-.45s.03-.05.04-.07l.78.45s-.03.05-.04.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m80.82,22.46l-.78-.45s.03-.05.05-.07l.78.45s-.03.05-.05.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m80.86,22.39l-.78-.45s.04-.05.06-.08l.78.45s-.04.05-.06.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m80.92,22.31l-.78-.45s.04-.06.07-.08l.78.45s-.05.05-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m80.99,22.23l-.78-.45s.06-.07.09-.1l.78.45s-.06.06-.09.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m81.08,22.13l-.78-.45c.09-.09.18-.16.28-.21l.78.45c-.1.06-.19.13-.28.21"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m81.35,21.92c.45-.26.82-.05.82.47s-.36,1.16-.82,1.42-.83.06-.83-.47.37-1.16.82-1.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m76.52,27.88l-.78-.45s.02.01.04.02l.78.45s-.02-.01-.04-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m76.56,27.9l-.78-.45c.11.06.22.12.34.17l.78.45c-.12-.05-.23-.1-.34-.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m76.9,28.07l-.78-.45c.12.05.23.09.36.13l.78.45c-.12-.04-.24-.08-.36-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m77.25,28.19l-.78-.45c.12.04.25.06.38.09l.78.45c-.13-.02-.26-.05-.38-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m77.63,28.28l-.78-.45c.13.02.27.04.41.05l.78.45c-.14,0-.28-.02-.41-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m78.04,28.33l-.78-.45c.15,0,.29.01.45,0l.78.45c-.15,0-.3,0-.45,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m78.49,28.33l-.78-.45c.16,0,.33-.02.5-.05l.78.45c-.17.03-.34.04-.5.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m78.99,28.28l-.78-.45c.19-.03.39-.07.59-.13l.78.45c-.2.05-.4.1-.59.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m79.58,28.16l-.78-.45c.26-.07.52-.16.79-.27l.78.45c-.27.11-.53.2-.79.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m80.37,27.88l-.78-.45c.31-.13.62-.28.94-.47l.78.45c-.32.18-.63.34-.94.47"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m81.31,27.42l-.78-.45c.79-.45,1.54-1.04,2.24-1.74l.78.45c-.7.69-1.45,1.28-2.24,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m83.55,25.68l-.78-.45c.25-.25.5-.51.73-.78l.78.45c-.24.27-.48.53-.73.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m84.29,24.9l-.78-.45c.19-.22.37-.44.55-.67l.78.45c-.18.23-.36.45-.55.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m84.83,24.23l-.78-.45c.15-.2.3-.4.45-.61l.78.45c-.15.21-.3.41-.45.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m85.28,23.62l-.78-.45c.13-.19.26-.39.39-.58l.78.45c-.13.2-.26.39-.39.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m85.67,23.04l-.78-.45c.12-.19.24-.38.35-.57l.78.45c-.11.19-.23.38-.35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m86.02,22.47l-.78-.45c.11-.19.22-.38.32-.57l.78.45c-.1.19-.21.38-.32.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m86.34,21.9l-.78-.45c.1-.19.2-.38.29-.58l.78.45c-.09.19-.19.39-.29.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m86.63,21.32l-.78-.45c.09-.19.18-.39.27-.59l.78.45c-.09.2-.17.39-.27.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m86.9,20.74l-.78-.45c.09-.2.17-.4.25-.61l.78.45c-.08.2-.16.41-.25.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m87.15,20.13l-.78-.45c.08-.21.16-.42.23-.64l.78.45c-.07.21-.15.43-.23.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m87.38,19.49l-.78-.45c.08-.23.15-.46.21-.69l.78.45c-.06.23-.13.46-.21.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m87.59,18.8l-.78-.45c.07-.26.13-.52.19-.77l.78.45c-.05.26-.12.52-.19.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m87.78,18.03l-.78-.45c.07-.31.12-.62.16-.93l.78.45c-.04.31-.09.62-.16.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m87.94,17.1l-.78-.45c.06-.44.09-.88.09-1.31,0-2.12-.76-3.62-1.97-4.32l.78.45c1.21.7,1.96,2.2,1.97,4.32,0,.43-.03.87-.09,1.31"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m81.39,18.82l-.78-.45c.11-.07.23-.12.35-.17l.78.45c-.12.05-.23.11-.35.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m81.74,18.65l-.78-.45c.1-.04.2-.08.3-.1l.78.45c-.1.03-.2.06-.3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m82.04,18.54l-.78-.45c.08-.02.16-.04.24-.05l.78.45c-.08.01-.16.03-.24.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m82.28,18.49l-.78-.45c.07-.01.14-.02.22-.02l.78.45c-.07,0-.14.01-.22.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m82.5,18.47l-.78-.45c.07,0,.14,0,.2,0l.78.45c-.07,0-.14,0-.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m82.7,18.47l-.78-.45c.07,0,.13.01.2.02l.78.45c-.07-.01-.13-.02-.2-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m82.9,18.5l-.78-.45c.07.01.13.03.2.05l.78.45c-.07-.02-.13-.03-.2-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m83.1,18.54l-.78-.45c.07.02.13.04.2.07l.78.45c-.07-.03-.13-.05-.2-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m83.3,18.61l-.78-.45c.07.03.14.06.21.1l.78.45c-.07-.04-.14-.07-.21-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m83.51,18.71l-.78-.45s.02,0,.02.01l.78.45s-.02,0-.02-.01"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-106",
    points: "78.79 21.78 78.02 21.33 78.02 21.33 78.79 21.78 78.79 21.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-106",
    points: "78.79 21.78 78.02 21.33 78.02 21.32 78.8 21.77 78.79 21.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m78.8,21.77l-.78-.45s.01-.03.03-.05l.78.45s-.02.04-.03.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m78.83,21.72l-.78-.45s.07-.13.13-.23l.78.45c-.06.1-.1.18-.13.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m78.95,21.49l-.78-.45c.06-.1.13-.21.21-.35l.78.45c-.08.13-.16.25-.21.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m79.17,21.14l-.78-.45c.08-.12.16-.25.26-.39l.78.45c-.1.14-.18.27-.26.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m79.42,20.76l-.78-.45s.06-.08.09-.12c.06-.09.13-.17.2-.26l.78.45c-.07.09-.13.18-.2.26-.03.04-.06.08-.09.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m79.71,20.37l-.78-.45c.1-.12.2-.25.31-.38l.78.45c-.11.13-.21.25-.31.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m80.02,19.99l-.78-.45c.12-.14.24-.27.37-.4l.78.45c-.13.13-.26.26-.37.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m80.39,19.59l-.78-.45c.29-.29.62-.56.98-.76l.78.45c-.35.2-.68.47-.98.76"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m81.37,18.83l-.78-.45s.01,0,.02-.01l.78.45s-.01,0-.02.01"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m78.82,22.43l-.78-.45c-.1-.06-.14-.19-.12-.36l.78.45c-.02.16.02.3.12.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m78.7,22.08l-.78-.45s0-.04.01-.06l.78.45s0,.04-.01.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m78.71,22.02l-.78-.45s0-.03.01-.05l.78.45s0,.03-.01.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m78.72,21.97l-.78-.45s0-.03.01-.04l.78.45s0,.03-.01.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m78.73,21.93l-.78-.45s0-.03.01-.04l.78.45s0,.03-.01.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m78.74,21.89l-.78-.45s0-.02.02-.04l.78.45s-.01.02-.02.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m78.76,21.85l-.78-.45s.01-.02.02-.04l.78.45s-.01.02-.02.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m78.78,21.81l-.78-.45s.01-.02.02-.03l.78.45s-.01.02-.02.03"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m77.26,20.91l-.78-.45c-.13-.07-.18-.25-.15-.45l.78.45c-.03.21.02.38.15.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m77.12,20.46l-.78-.45s0-.05.01-.08l.78.45s0,.05-.01.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m77.13,20.38l-.78-.45s0-.04.02-.06l.78.45s-.01.04-.02.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m77.14,20.31l-.78-.45s.01-.04.02-.06l.78.45s-.01.04-.02.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m77.16,20.26l-.78-.45s.01-.03.02-.05l.78.45s-.01.03-.02.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m77.18,20.21l-.78-.45s.01-.03.02-.05l.78.45s-.01.03-.02.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m77.2,20.16l-.78-.45s.01-.03.02-.05l.78.45s-.01.03-.02.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m77.22,20.11l-.78-.45s.02-.03.02-.05l.78.45s-.02.03-.02.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m77.25,20.06l-.78-.45s.02-.03.02-.04c0,0,0,0,0,0l.78.45s0,0,0,0c0,.01-.02.03-.02.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m77.27,20.01l-.78-.45s.08-.14.19-.3l.78.45c-.11.17-.17.28-.19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m77.46,19.71l-.78-.45c.09-.15.22-.34.37-.56l.78.45c-.15.22-.28.41-.37.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m77.83,19.15l-.78-.45c.14-.2.3-.42.48-.65l.78.45c-.18.24-.34.46-.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m78.31,18.5l-.78-.45c.05-.06.1-.12.14-.18.14-.18.3-.37.46-.55l.78.45c-.16.19-.32.38-.46.55-.05.06-.1.12-.14.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m78.92,17.76l-.78-.45c.22-.25.45-.5.7-.75l.78.45c-.25.25-.49.5-.7.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m79.62,17.01l-.78-.45c.53-.53,1.14-1.03,1.8-1.41l.78.45c-.66.38-1.27.89-1.8,1.41"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m81.43,15.6l-.78-.45s.02-.01.03-.02l.78.45s-.02.01-.03.02"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-97",
    points: "77.27 20.91 76.49 20.46 76.49 20.45 77.26 20.91 77.27 20.91"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m81.45,15.58c1.21-.7,2.57-.93,3.84-.19.22.12.22.52,0,.89-.11.18-.24.32-.38.4s-.28.1-.39.04c-1.12-.63-2.16-.4-3.1.13-.91.53-1.74,1.39-2.36,2.16-.61.76-1.01,1.42-1.04,1.46-.11.18-.25.32-.39.41s-.28.1-.39.04c-.21-.12-.21-.52,0-.89.02-.04.46-.78,1.19-1.7.73-.91,1.75-2.02,2.97-2.72,0,0,.02-.01.03-.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m76.1,28.6l-.78-.45c-1.32-.76-2.13-2.39-2.14-4.7,0-.47.03-.95.09-1.43l.78.45c-.06.48-.09.96-.09,1.43,0,2.31.82,3.93,2.14,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m74.06,22.47l-.78-.45c.04-.34.1-.67.17-1.02l.78.45c-.07.34-.13.68-.17,1.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m74.23,21.45l-.78-.45c.06-.28.13-.56.21-.84l.78.45c-.08.28-.15.56-.21.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m74.44,20.61l-.78-.45c.07-.25.15-.5.23-.75l.78.45c-.08.25-.16.5-.23.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m74.67,19.87l-.78-.45c.08-.23.16-.46.25-.69l.78.45c-.09.23-.17.46-.25.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m74.91,19.17l-.78-.45c.08-.22.17-.44.27-.66l.78.45c-.09.22-.18.44-.27.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m75.18,18.52l-.78-.45c.09-.21.19-.43.29-.64l.78.45c-.1.21-.2.42-.29.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m75.48,17.88l-.78-.45c.1-.21.21-.42.32-.62l.78.45c-.11.21-.21.41-.32.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m75.79,17.26l-.78-.45c.11-.21.23-.41.34-.62l.78.45c-.12.2-.23.41-.34.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m76.14,16.64l-.78-.45c.12-.21.25-.42.38-.62l.78.45c-.13.2-.26.41-.38.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m76.51,16.02l-.78-.45c.14-.21.28-.43.42-.63l.78.45c-.15.21-.29.42-.42.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m76.94,15.39l-.78-.45c.16-.23.32-.45.49-.66l.78.45c-.17.22-.33.44-.49.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m77.43,14.72l-.78-.45c.19-.25.39-.49.59-.72l.78.45c-.2.23-.4.48-.59.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m78.02,14l-.78-.45c.26-.3.53-.58.8-.85l.78.45c-.27.27-.54.56-.8.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m78.82,13.15l-.78-.45c.76-.75,1.59-1.4,2.45-1.89l.78.45c-.86.5-1.68,1.14-2.45,1.89"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m81.27,11.25c4.04-2.33,7.34-.46,7.35,4.19s-3.27,10.32-7.3,12.65-7.34.45-7.35-4.19c-.01-4.65,3.26-10.31,7.3-12.65Zm.05,16.16c3.71-2.14,6.72-7.37,6.71-11.63s-3.04-6-6.76-3.86c-3.72,2.15-6.73,7.36-6.72,11.64s3.04,6,6.76,3.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m83.78,18.9c-.77-.6-1.63-.52-2.4-.08,0,0-.01,0-.02.01-.77.44-1.41,1.19-1.85,1.8-.44.61-.7,1.11-.72,1.15-.15.29-.13.59.04.66.08.03.18.01.27-.04.12-.07.24-.2.33-.37.04-.07.27-.5.63-.97.35-.47.81-.97,1.3-1.25.52-.29,1.1-.4,1.77.1.09.06.21.05.33-.02.1-.06.19-.15.27-.27.18-.28.2-.6.04-.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m81.27,11.25l-.78-.45c.35-.2.69-.37,1.02-.51l.78.45c-.33.14-.68.31-1.02.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m82.29,10.74l-.78-.45c.29-.12.58-.22.86-.3l.78.45c-.28.08-.57.18-.86.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m83.15,10.45l-.78-.45c.22-.06.43-.11.64-.14l.78.45c-.21.03-.43.08-.64.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m83.79,10.31l-.78-.45c.19-.03.37-.05.55-.05l.78.45c-.18,0-.36.03-.55.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m84.34,10.26l-.78-.45c.17,0,.33,0,.49,0l.78.45c-.16,0-.32-.01-.49,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m84.83,10.26l-.78-.45c.15,0,.3.03.44.05l.78.45c-.14-.03-.29-.04-.44-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m85.27,10.31l-.78-.45c.14.02.28.06.41.1l.78.45c-.13-.04-.27-.07-.41-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m85.68,10.41l-.78-.45c.13.04.26.08.39.14l.78.45c-.13-.05-.25-.1-.39-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m86.07,10.54l-.78-.45c.13.05.25.11.37.18l.78.45c-.12-.07-.24-.13-.37-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m86.44,10.72l-.78-.45s.03.02.04.02l.78.45s-.03-.02-.04-.02"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "13.73 23.9 13.77 36.74 13.18 37.08 13.14 24.24 13.73 23.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "13.18 37.08 12.4 36.63 12.36 23.79 13.14 24.24 13.18 37.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "13.14 24.24 12.36 23.79 12.96 23.45 13.73 23.9 13.14 24.24"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-106",
    points: "13.71 17.33 12.93 16.87 12.93 16.88 13.71 17.33 13.71 17.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m13.71,17.33l-.78-.45s.01,0,.02,0l.78.45s-.01,0-.02,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m13.73,17.34l-.78-.45s.01,0,.02,0l.78.45s-.01,0-.02,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m13.75,17.34l-.78-.45s.02,0,.03,0l.78.45s-.02,0-.03,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m13.77,17.35l-.78-.45s.02,0,.04,0l.78.45s-.02,0-.04,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m13.81,17.35l-.78-.45s.03,0,.05,0l.78.45s-.04,0-.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m13.86,17.35l-.78-.45s.06,0,.08,0l.78.45s-.06,0-.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m13.95,17.35l-.78-.45c.05,0,.1-.02.14-.03l.78.45s-.09.02-.14.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m14.09,17.31l-.78-.45s.08-.03.09-.03l.78.45s-.04.01-.09.03"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "12.67 19.98 11.89 19.52 11.88 14.79 12.66 15.24 12.67 19.98"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m13.43,21.66l-.78-.45c.79-.46,1.55-1.05,2.25-1.74l.78.45c-.7.69-1.46,1.29-2.25,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m15.68,19.91l-.78-.45c.25-.25.5-.51.74-.78l.78.45c-.24.27-.48.54-.74.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m16.42,19.13l-.78-.45c.19-.22.37-.44.55-.67l.78.45c-.18.23-.36.45-.55.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m16.97,18.46l-.78-.45c.15-.2.3-.4.45-.61l.78.45c-.15.21-.3.41-.45.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m17.41,17.85l-.78-.45c.13-.19.26-.39.39-.58l.78.45c-.13.2-.26.39-.39.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m17.81,17.27l-.78-.45c.12-.19.24-.38.35-.57l.78.45c-.11.19-.23.38-.35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m18.15,16.7l-.78-.45c.11-.19.22-.38.32-.57l.78.45c-.1.19-.21.38-.32.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m18.47,16.13l-.78-.45c.1-.19.2-.38.29-.57l.78.45c-.09.19-.19.38-.29.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m18.76,15.56l-.78-.45c.09-.19.18-.39.27-.59l.78.45c-.09.2-.17.39-.27.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m19.03,14.97l-.78-.45c.09-.2.17-.4.25-.6l.78.45c-.08.2-.16.4-.25.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m19.28,14.37l-.78-.45c.08-.21.16-.42.23-.64l.78.45c-.07.21-.15.42-.23.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m19.51,13.73l-.78-.45c.08-.23.15-.46.21-.69l.78.45c-.06.23-.13.46-.21.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m19.71,13.04l-.78-.45c.07-.26.13-.52.19-.77l.78.45c-.05.26-.12.51-.19.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m19.9,12.27l-.78-.45c.07-.31.12-.62.16-.93l.78.45c-.04.31-.09.62-.16.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m20.06,11.34l-.78-.45c.06-.44.09-.88.09-1.31,0-2.12-.76-3.62-1.97-4.32l.78.45c1.21.7,1.96,2.2,1.97,4.32,0,.43-.03.87-.09,1.31"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m8.64,22.12l-.78-.45s.02.01.04.02l.78.45s-.02-.01-.04-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m8.67,22.14l-.78-.45c.11.06.22.12.34.17l.78.45c-.12-.05-.23-.1-.34-.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m9.01,22.31l-.78-.45c.12.05.23.09.36.13l.78.45c-.12-.04-.24-.08-.36-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m9.37,22.44l-.78-.45c.12.04.25.07.38.09l.78.45c-.13-.02-.26-.05-.38-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m9.75,22.52l-.78-.45c.13.02.27.04.41.05l.78.45c-.14,0-.28-.02-.41-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m10.16,22.57l-.78-.45c.15,0,.29.01.45,0l.78.45c-.15,0-.3,0-.45,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m10.6,22.57l-.78-.45c.16,0,.33-.02.5-.05l.78.45c-.17.03-.34.04-.5.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m11.11,22.52l-.78-.45c.19-.03.39-.07.59-.13l.78.45c-.2.05-.4.1-.59.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m11.7,22.4l-.78-.45c.26-.07.52-.16.79-.27l.78.45c-.27.11-.53.2-.79.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m12.49,22.12l-.78-.45c.31-.13.62-.28.94-.47l.78.45c-.32.18-.63.34-.94.47"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m13.4,12.03l-.78-.45c.1-.06.2-.13.28-.22l.78.45c-.09.09-.19.16-.28.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m13.69,11.81l-.78-.45s.06-.07.09-.1l.78.45s-.06.07-.09.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m13.78,11.71l-.78-.45s.05-.06.07-.09l.78.45s-.05.06-.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m13.85,11.62l-.78-.45s.04-.05.06-.08l.78.45s-.04.05-.06.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m13.91,11.55l-.78-.45s.03-.05.05-.08l.78.45s-.03.05-.05.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m13.96,11.47l-.78-.45s.03-.05.04-.07l.78.45s-.03.05-.04.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m14.01,11.4l-.78-.45s.03-.05.04-.07l.78.45s-.03.05-.04.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m14.05,11.32l-.78-.45s.03-.05.04-.07l.78.45s-.02.05-.04.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m14.08,11.25l-.78-.45s.02-.05.03-.08l.78.45s-.02.05-.03.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m14.12,11.17l-.78-.45s.02-.05.03-.08l.78.45s-.02.05-.03.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m14.15,11.1l-.78-.45s.02-.05.03-.08l.78.45s-.02.05-.03.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m14.18,11.01l-.78-.45s.02-.06.03-.09l.78.45s-.02.06-.03.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m14.21,10.93l-.78-.45s.02-.07.02-.1l.78.45s-.02.07-.02.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m14.23,10.83l-.78-.45s.02-.08.02-.12l.78.45s-.01.08-.02.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m14.25,10.71l-.78-.45c0-.06.01-.11.01-.17,0-.27-.1-.46-.25-.55l.78.45c.15.09.25.28.25.55,0,.05,0,.11-.01.17"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-106",
    points: "12.79 12.09 12.01 11.64 12.02 11.64 12.8 12.09 12.79 12.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m12.8,12.09l-.78-.45s.03.02.04.02l.78.45s-.03-.01-.04-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m12.84,12.11l-.78-.45s.03.01.05.02l.78.45s-.03,0-.05-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m12.89,12.13l-.78-.45s.03,0,.05.01l.78.45s-.03,0-.05-.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m12.94,12.14l-.78-.45s.03,0,.05,0l.78.45s-.04,0-.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m12.99,12.15l-.78-.45s.04,0,.06,0l.78.45s-.04,0-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m13.05,12.15l-.78-.45s.04,0,.06,0l.78.45s-.04,0-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m13.11,12.14l-.78-.45s.05,0,.08-.02l.78.45s-.05.01-.08.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m13.18,12.12l-.78-.45s.07-.02.1-.03l.78.45s-.07.03-.1.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m13.29,12.09l-.78-.45s.08-.04.12-.06l.78.45s-.08.04-.12.06"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m11.51,15.11l-.78-.45c-.48-.28-.78-.87-.78-1.72,0-.17.01-.35.03-.52l.78.45c-.02.18-.03.35-.03.52,0,.84.3,1.44.78,1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m10.76,12.87l-.78-.45c.02-.12.04-.25.06-.37l.78.45c-.03.12-.05.25-.06.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m10.83,12.5l-.78-.45c.02-.1.05-.2.08-.31l.78.45c-.03.1-.05.2-.08.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m10.9,12.2l-.78-.45c.03-.09.05-.18.08-.27l.78.45c-.03.09-.06.18-.08.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m10.99,11.93l-.78-.45c.03-.08.06-.17.09-.25l.78.45c-.03.08-.06.17-.09.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m11.08,11.67l-.78-.45c.03-.08.06-.16.1-.24l.78.45c-.03.08-.07.16-.1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m11.17,11.43l-.78-.45c.03-.08.07-.16.11-.23l.78.45c-.04.08-.07.15-.11.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m11.28,11.2l-.78-.45c.04-.08.08-.15.12-.23l.78.45c-.04.08-.08.15-.12.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m11.4,10.97l-.78-.45c.04-.08.08-.15.13-.23l.78.45c-.04.07-.09.15-.13.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m11.52,10.75l-.78-.45c.04-.08.09-.15.14-.23l.78.45c-.05.07-.09.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m11.66,10.52l-.78-.45c.05-.08.1-.16.16-.23l.78.45c-.05.08-.11.15-.16.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m11.82,10.29l-.78-.45c.06-.08.12-.16.18-.24l.78.45c-.06.08-.12.16-.18.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m11.99,10.04l-.78-.45c.07-.09.14-.18.22-.26l.78.45c-.07.09-.15.17-.22.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m12.21,9.78l-.78-.45c.09-.11.19-.21.29-.31l.78.45c-.1.1-.2.2-.29.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m12.5,9.47l-.78-.45c.28-.27.58-.51.89-.69.13-.07.25-.14.38-.19l.78.45c-.12.05-.25.11-.38.19-.31.18-.61.42-.89.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m13.77,8.59l-.78-.45c.11-.04.21-.08.32-.11l.78.45c-.1.03-.21.06-.32.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m14.09,8.48l-.78-.45c.08-.02.16-.04.24-.05l.78.45c-.08.01-.16.03-.24.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m14.32,8.43l-.78-.45c.07-.01.13-.02.2-.02l.78.45c-.07,0-.13,0-.2.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m14.52,8.41l-.78-.45c.06,0,.12,0,.18,0l.78.45c-.06,0-.12,0-.18,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m14.7,8.41l-.78-.45c.05,0,.11,0,.16.02l.78.45c-.05,0-.11-.02-.16-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m14.86,8.43l-.78-.45c.05,0,.1.02.15.03l.78.45s-.1-.03-.15-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m15.01,8.47l-.78-.45s.1.03.14.05l.78.45s-.09-.04-.14-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m15.15,8.52l-.78-.45s.09.04.13.07l.78.45s-.09-.05-.13-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m15.28,8.58l-.78-.45s0,0,.01,0l.78.45s0,0-.01,0"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m14.03,16.27c-.38.34-.38.71-.38.95s.5.07.52.06v.49s-1.19,2.26-1.19,2.26l-.32-.06v-4.74c-1.12.27-1.94-.45-1.94-1.84,0-1.69,1.19-3.77,2.67-4.62s2.68-.17,2.68,1.53c0,1.46-.87,3.17-2.05,4.18v1.78Zm-.63-4.24c.47-.27.86-.94.86-1.49s-.39-.77-.86-.49-.86.94-.86,1.49.39.77.86.49"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m13.39,5.5l-.78-.45c.35-.2.69-.37,1.02-.51l.78.45c-.33.14-.68.31-1.02.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m14.41,4.99l-.78-.45c.29-.12.58-.22.86-.3l.78.45c-.28.08-.57.18-.86.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m15.27,4.7l-.78-.45c.22-.06.43-.11.64-.14l.78.45c-.21.03-.43.08-.64.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m15.91,4.56l-.78-.45c.19-.03.37-.05.55-.05l.78.45c-.18,0-.36.03-.55.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m16.46,4.5l-.78-.45c.17,0,.33,0,.49,0l.78.45c-.16,0-.32-.01-.49,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m16.94,4.51l-.78-.45c.15,0,.3.03.44.05l.78.45c-.14-.03-.29-.04-.44-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m17.39,4.56l-.78-.45c.14.02.28.06.41.1l.78.45c-.13-.04-.27-.07-.41-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m17.8,4.66l-.78-.45c.13.04.26.08.39.14l.78.45c-.13-.05-.25-.1-.39-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m18.19,4.79l-.78-.45c.13.05.25.11.37.18l.78.45c-.12-.07-.24-.13-.37-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m18.56,4.97l-.78-.45s.03.02.04.02l.78.45s-.03-.02-.04-.02"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m8.22,22.84l-.78-.45c-1.32-.76-2.13-2.39-2.14-4.69,0-.47.03-.95.09-1.43l.78.45c-.06.48-.09.96-.09,1.43,0,2.3.82,3.93,2.14,4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m6.18,16.72l-.78-.45c.04-.34.1-.67.17-1.01l.78.45c-.07.34-.13.68-.17,1.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m6.35,15.71l-.78-.45c.06-.28.13-.56.21-.84l.78.45c-.08.28-.15.56-.21.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m6.56,14.87l-.78-.45c.07-.25.15-.5.23-.75l.78.45c-.08.25-.16.5-.23.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m6.79,14.12l-.78-.45c.08-.23.16-.46.25-.69l.78.45c-.09.23-.17.46-.25.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m7.03,13.43l-.78-.45c.08-.22.17-.44.27-.66l.78.45c-.09.22-.18.44-.27.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m7.3,12.77l-.78-.45c.09-.21.19-.43.29-.64l.78.45c-.1.21-.2.42-.29.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m7.59,12.13l-.78-.45c.1-.21.21-.42.32-.62l.78.45c-.11.21-.22.41-.32.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m7.91,11.51l-.78-.45c.11-.21.23-.41.34-.62l.78.45c-.12.2-.23.41-.34.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m8.25,10.89l-.78-.45c.12-.21.25-.42.38-.62l.78.45c-.13.2-.26.41-.38.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m8.63,10.27l-.78-.45c.14-.21.28-.43.43-.63l.78.45c-.15.21-.29.42-.43.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m9.06,9.63l-.78-.45c.16-.23.32-.45.49-.66l.78.45c-.17.22-.33.44-.49.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m9.55,8.97l-.78-.45c.19-.25.39-.49.6-.73l.78.45c-.2.23-.4.48-.6.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m10.14,8.25l-.78-.45c.26-.3.53-.58.8-.85l.78.45c-.27.27-.54.56-.8.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m10.94,7.39l-.78-.45c.76-.75,1.59-1.4,2.44-1.89l.78.45c-.86.49-1.68,1.14-2.44,1.89"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m13.39,5.5c4.04-2.33,7.34-.46,7.35,4.19s-3.27,10.32-7.3,12.65-7.34.45-7.35-4.19,3.27-10.32,7.3-12.65Zm.05,16.15c3.72-2.15,6.73-7.36,6.72-11.63-.01-4.27-3.04-6-6.76-3.85s-6.73,7.36-6.72,11.64,3.05,5.99,6.76,3.85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAutomation);
export default __webpack_public_path__ + "static/media/home-automation.0d5efc36f49f1c2aa5f38aa8dbe25558.svg";
export { ForwardRef as ReactComponent };